import React from 'react'
import * as yup from 'yup'
import { FormattedMessage } from 'react-intl'
import { parse, isDate } from 'date-fns'
import CookiesStorageService from '../Services/CookiesStorageService'

function parseDateString (value, originalValue) {
  const parsedDate = isDate(originalValue)
    ? originalValue
    : parse(originalValue, 'dd-MM-yyyy HH:mm a', new Date())

  return parsedDate
}

export const LateSubmissionNewRequest = yup.object().shape({
  reasonId: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  reasonDescription: yup.string().trim().when('reasonId', (reasonId) => {
    return (reasonId === '1') ? yup.string().trim().required(<FormattedMessage
      id='validationSchema.required'/>) : yup.string().trim()
  })
})
export const CreateInvoiceStep1FormValidation = yup.object().shape({
  documentType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  documentTypeVersion: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  documentSubType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  internalID: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  lastReferences: yup.string().when('documentType', (documentType) => {
    return ['C', 'D', 'EC', 'ED'].includes(documentType)
      ? yup.lazy(value => !value ? yup.string() : yup.string()
        .matches(/^[A-Z0-9]{25,30}$/,
          { message: <FormattedMessage id='validationSchema.reference'/> }))
      : yup.string()
  }),
  serviceDeliveryDate: yup.string().when('documentType', (documentType) => {
    return ['EI', 'EC', 'ED'].includes(documentType)
      ? yup.date().transform(parseDateString).required(<FormattedMessage id='validationSchema.required'/>)
      : yup.string()
  }),
  referencesListCheck: yup.string().when('documentType', (documentType) => {
    return ['EC', 'ED'].includes(documentType)
      ? yup.boolean().required(<FormattedMessage id='validationSchema.required'/>)
        .oneOf([true], <FormattedMessage id='validationSchema.required'/>)
      : yup.boolean()
  })
})
export const CreateInvoiceStep2FormValidation = yup.object().shape({
  taxpayerActivityCode: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  issuerType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  issuerID: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  issuerName: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  issuerBranchID: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  issuerAddress: yup.object().shape({
    country: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
    governate: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
    regionCity: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
    street: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
    buildingNumber: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
    floor: yup.string().trim(),
    room: yup.string().trim(),
    landmark: yup.string().trim(),
    postalCode: yup.string().trim(),
    additionalInformation: yup.string().trim()
  }).nullable().required(<FormattedMessage id='validationSchema.address.required'/>),
  receiverType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  // receiverName: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  receiverName: yup.string().when(['receiverType', 'itemsAmount', 'invoicePersonalLimit'], (type, amount, invoicePersonalLimit) => {
    return !!type && ((type === 'P' && (!invoicePersonalLimit || parseFloat(amount) < parseFloat(invoicePersonalLimit))) || type === 'B') ? yup.string().trim() :
      yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
  }),
  receiverID: yup.string().when(['receiverType', 'itemsAmount', 'invoicePersonalLimit'], (val, amount, invoicePersonalLimit) => {
    if (!!val) {
      switch (val) {
        case 'B':
          return yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
            .matches(/^[0-9]+$/, { message: <FormattedMessage id='validationSchema.taxOnlyNumbers'/> })
            .min(9, <FormattedMessage id='validationSchema.taxLengthMin'/>)
            .max(9, <FormattedMessage id='validationSchema.taxLengthMax'/>)
            .test('checkReceiverTRN', <FormattedMessage id='validationSchema.ReceiverTRN'/>, function(value) {
              return new Promise((resolve, reject) => {
                if (!!value) {
                  resolve((value?.toString() !== CookiesStorageService.getTaxpayerTRN()?.toString()))
                } else {
                  resolve(false)
                }
              })
            })
        case 'P':
          return !invoicePersonalLimit || parseFloat(amount) < parseFloat(invoicePersonalLimit) ? yup.string().trim()
              .matches(/^[0-9]+$/, { message: <FormattedMessage id='validationSchema.socialNumberOnlyNumbers'/> })
              // .matches(/(2|3)[0-9][0-9][0-1][0-9][0-3][0-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/, {
              .matches(/^([2-3]{1})([0-9]{2})(01|02|03|04|05|06|07|08|09|10|11|12)(0[1-9]|[12]\d|3[01])([0-9]{2})[0-9]{3}([0-9]{1})[0-9]{1}$/, {
                message: <FormattedMessage id='validationSchema.socialNumberInvalid'/>
              })
              .min(14, <FormattedMessage id='validationSchema.socialNumberLengthMin'/>)
              .max(14, <FormattedMessage id='validationSchema.socialNumberLengthMax'/>) :
            yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
              .matches(/^[0-9]+$/, { message: <FormattedMessage id='validationSchema.socialNumberOnlyNumbers'/> })
              // .matches(/(2|3)[0-9][0-9][0-1][0-9][0-3][0-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/, {
              .matches(/^([2-3]{1})([0-9]{2})(01|02|03|04|05|06|07|08|09|10|11|12)(0[1-9]|[12]\d|3[01])([0-9]{2})[0-9]{3}([0-9]{1})[0-9]{1}$/, {
                message: <FormattedMessage id='validationSchema.socialNumberInvalid'/>
              })
              .min(14, <FormattedMessage id='validationSchema.socialNumberLengthMin'/>)
              .max(14, <FormattedMessage id='validationSchema.socialNumberLengthMax'/>)
        case 'F':
          return yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
            // .matches(/^[a-zA-Z0-9]+$/, {
            //   message: <FormattedMessage id='validationSchema.passportEnglishNumberOnlyNumbers'/>
            // })
            .max(30, <FormattedMessage id='validationSchema.passportNumberLengthMax'/>)
        default:
          return yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
      }
    } else {
      return yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
    }
  }),
  receiverAddress: yup.object().when(['receiverType', 'itemsAmount', 'invoicePersonalLimit'], (type, amount, invoicePersonalLimit) => {
    return !!type && type === 'P' && (!invoicePersonalLimit || parseFloat(amount) < parseFloat(invoicePersonalLimit)) ? yup.object() :
      yup.object().shape({
        country: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
        governate: type === 'F' ? yup.string() : yup.string().trim().required(<FormattedMessage
          id='validationSchema.required'/>),
        regionCity: type === 'F' ? yup.string() : yup.string().trim().required(<FormattedMessage
          id='validationSchema.required'/>),
        street: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
        buildingNumber: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
        floor: yup.string().trim(),
        room: yup.string().trim(),
        landmark: yup.string().trim(),
        postalCode: yup.string().trim(),
        additionalInformation: yup.string().trim()
      }).nullable().required(<FormattedMessage id='validationSchema.address.required'/>)
  })
})

export const addressFormValidation = yup.object().shape({
  country: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  governate: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  regionCity: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  street: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  buildingNumber: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  floor: yup.string().trim(),
  room: yup.string().trim(),
  landmark: yup.string().trim(),
  postalCode: yup.string().trim(),
  additionalInformation: yup.string().trim()
})
export const CreateInvoiceStep3FormValidation = yup.object().shape({
  invoiceLines: yup.array().nullable().min(1, <FormattedMessage id='validationSchema.required'/>),
  totalSalesAmount: yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(
    <FormattedMessage id='validationSchema.required'/>),
  totalDiscountAmount: yup.number(),
  netAmount: yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
    id='validationSchema.required'/>),
  totalItemsDiscountAmount: yup.number(),
  taxTotals: yup.array().nullable(),
  // extraDiscountAmount: yup.number(),
  extraDiscountAmount: yup.number().test('exceedsTotal', <FormattedMessage
    id='validationSchema.discountExceedsTotal'/>, (val, schema) => {
    return !val || (!!val && parseFloat(schema.parent.totalAmount) >= 0)
  }),
  totalAmount: yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
    id='validationSchema.required'/>)
})

export const CreateInvoiceStep4FormValidation = yup.object().shape({
  swiftCode: yup.lazy(value => !value ? yup.string() : yup.string()
    .matches(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
      { message: <FormattedMessage id='validationSchema.swiftCode'/> })),
  bankAccountIBAN: yup.lazy(value => !value ? yup.string() : yup.string()
    .matches(/^([A-Z]{2}[ -]?[0-9]{2})(?=(?:[ -]?[A-Z0-9]){9,30}$)((?:[ -]?[A-Z0-9]{3,5}){2,7})([ -]?[A-Z0-9]{1,3})?$/,
      { message: <FormattedMessage id='validationSchema.IBAN'/> }))
})

export const AddNewTaxItemFormValidation = yup.object().shape({
  id: yup.string(),
  type: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  subType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  rate: yup.string().when('fixedAmount', (fixedAmount) => {
    return !!fixedAmount ? yup.string() : yup.string().trim().required(<FormattedMessage
      id='validationSchema.required'/>)
  }),
  value: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
})

export const cancelInvoiceFormValidation = yup.object().shape({
  reason: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  otherReason: yup.string().when('reason', (reason) => {
    return !!reason && reason === 'otherReason' ? yup.string().trim().required(<FormattedMessage
      id='validationSchema.required'/>) : yup.string()
  }),
  status: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
})
export const templateSaveFormValidation = yup.object().shape({
  name: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  privilegeId: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
})
export const CurrencyFormValidation = yup.object().shape({
  id: yup.string(),
  key: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  rate: yup.number().moreThan(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
    id='validationSchema.required'/>)
})
export const codeUsageRequestFormValidation = yup.object().shape({
  codeType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  itemCode: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
})
export const codesBulkImportFormValidation = yup.object().shape({
  bulkType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  codesFile: yup.mixed().required(<FormattedMessage id='validationSchema.required'/>)
})
export const codeCreateRequestFormValidation = yup.object().shape({
  codeType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  itemCode: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  codeName: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  codeNameAr: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  description: yup.string().trim(),
  descriptionAr: yup.string().trim(),
  parentCode: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  activeFrom: yup.date().transform(parseDateString).required(<FormattedMessage id='validationSchema.required'/>)
})

export const packageCreateRequestFormValidation = yup.object().shape({
  type: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  format: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  dateFrom: yup.date().transform(parseDateString).required(<FormattedMessage id='validationSchema.required'/>),
  dateTo: yup.date().transform(parseDateString).required(<FormattedMessage id='validationSchema.required'/>),
  documentTypeNames: yup.array().nullable(),
  statuses: yup.array().nullable(),
  productsInternalCodes: yup.array().nullable(),
  itemCodes: yup.array().nullable(),
  receiverSenderId: yup.string().when('receiverSenderType', (val) => {
    if (!!val) {
      switch (val) {
        case 'B':
          return yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
            .matches(/^[0-9]+$/, { message: <FormattedMessage id='validationSchema.taxOnlyNumbers'/> })
            .min(9, <FormattedMessage id='validationSchema.taxLengthMin'/>)
            .max(9, <FormattedMessage id='validationSchema.taxLengthMax'/>)
        case 'P':
          return yup.string().trim()
            .matches(/^[0-9]+$/, { message: <FormattedMessage id='validationSchema.socialNumberOnlyNumbers'/> })
            // .matches(/(2|3)[0-9][0-9][0-1][0-9][0-3][0-9](01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/, {
            .matches(/^([2-3]{1})([0-9]{2})(01|02|03|04|05|06|07|08|09|10|11|12)(0[1-9]|[12]\d|3[01])([0-9]{2})[0-9]{3}([0-9]{1})[0-9]{1}$/, {
              message: <FormattedMessage id='validationSchema.socialNumberInvalid'/>
            })
            .min(14, <FormattedMessage id='validationSchema.socialNumberLengthMin'/>)
            .max(14, <FormattedMessage id='validationSchema.socialNumberLengthMax'/>)
        case 'F':
          return yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
            .matches(/^[a-zA-Z0-9]+$/, {
              message: <FormattedMessage id='validationSchema.passportEnglishNumberOnlyNumbers'/>
            })
        default:
          return yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
      }
    } else {
      return yup.string().trim()
    }
  })
})

export const InvoiceSignCertificateFormValidation = yup.object().shape({
  certificateSerialNumber: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
})

export const AddNewLineItemFormValidation = yup.object().shape({
  id: yup.string(),
  itemType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  itemCode: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  description: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  internalCode: yup.string().trim(),
  unitType: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  unitAmount: yup.number().when(['documentType', 'originItemValues'], (documentType, originItemValues) => {
    return ['C', 'EC'].includes(documentType)
      ? (!!parseFloat(originItemValues?.unitAmount || 0)
        ? yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>).max(parseFloat(originItemValues?.unitAmount || 0), <FormattedMessage
          id='validationSchema.exceedOriginValue'/>)
        : yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>))
      : (['D', 'ED'].includes(documentType)
        ? yup.number().min(parseFloat(originItemValues?.unitAmount) || 0, <FormattedMessage
          id='validationSchema.equalMoreOriginValue'/>).required(<FormattedMessage
          id='validationSchema.required'/>)
        : yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>))
  }),
  // unitAmount: yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
  //   id='validationSchema.required'/>),
  currencyRate: yup.object().shape({
    key: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
    rate: yup.number().moreThan(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
      id='validationSchema.required'/>)
  }).nullable().required(<FormattedMessage id='validationSchema.required'/>),
  amountSold: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  quantity: yup.number().when(['documentType', 'originItemValues'], (documentType, originItemValues) => {
    return ['C', 'EC'].includes(documentType)
      ? (!!parseFloat(originItemValues?.quantity || 0)
        ? yup.number().min(1, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>).max(parseFloat(originItemValues?.quantity || 0) || 1, <FormattedMessage
          id='validationSchema.exceedOriginValue'/>)
        : yup.number().min(1, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>))
      : (['D', 'ED'].includes(documentType)
        ? yup.number().min(parseFloat(originItemValues?.quantity || 0) || 1, <FormattedMessage
          id={!!parseFloat(originItemValues?.quantity || 0) ? 'validationSchema.equalMoreOriginValue' : 'validationSchema.required'}/>).required(
          <FormattedMessage id='validationSchema.required'/>)
        : yup.number().min(1, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>))
  }),
  weightQuantity: yup.number().when(['documentType', 'originItemValues'], (documentType, originItemValues) => {
    return ['EC'].includes(documentType)
      ? (!!parseFloat(originItemValues?.weightQuantity || 0)
        ? yup.number().min(1, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>).max(parseFloat(originItemValues?.weightQuantity || 0) || 1,
          <FormattedMessage id='validationSchema.exceedOriginValue'/>)
        : yup.number().min(1, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>))
      : (['EI', 'ED'].includes(documentType)
        ? yup.number().min(parseFloat(originItemValues?.weightQuantity || 0) || 1, <FormattedMessage
          id={!!parseFloat(originItemValues?.weightQuantity || 0) ? 'validationSchema.equalMoreOriginValue' : 'validationSchema.required'}/>).required(
          <FormattedMessage id='validationSchema.required'/>)
        : yup.number())
  }),
  weightUnitType: yup.string().when(['documentType', 'originItemValues'], (documentType, originItemValues) => {
    return ['EI', 'EC', 'ED'].includes(documentType)
      ? yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>)
      : yup.string()
  }),
  // quantity: yup.number().min(1, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
  //   id='validationSchema.required'/>),
  salesTotal: yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
    id='validationSchema.required'/>),
  discountRate: yup.number(),
  discountValue: yup.number(),
  netTotal: yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
    id='validationSchema.required'/>),
  taxableItems: yup.array().nullable(),
  totalTaxableFees: yup.number(),
  valueDifference: yup.number(),
  itemsDiscount: yup.number().min(0, <FormattedMessage id='validationSchema.required'/>),
  total: yup.number().when(['documentType', 'originItemValues'], (documentType, originItemValues) => {
    return ['C', 'EC'].includes(documentType)
      ? (!!parseFloat(originItemValues?.total || 0)
        ? yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>).max(parseFloat(originItemValues?.total || 0),
          <FormattedMessage id='validationSchema.exceedOriginValue'/>)
        : yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>))
      : (['D', 'ED'].includes(documentType)
        ? yup.number().min(parseFloat(originItemValues?.total) || 0, <FormattedMessage
          id='validationSchema.equalMoreOriginValue'/>).required(<FormattedMessage
          id='validationSchema.required'/>)
        : yup.number().min(0, <FormattedMessage id='validationSchema.required'/>).required(<FormattedMessage
          id='validationSchema.required'/>))
  })
})

export const dashboardFilterFormValidation = yup.object().shape({
  type: yup.string().trim().required(<FormattedMessage id='validationSchema.required'/>),
  year: yup.date(),
  dateFrom: yup.date().transform(parseDateString).required(<FormattedMessage
    id='validationSchema.required'/>),
  dateTo: yup.date().transform(parseDateString).required(<FormattedMessage
    id='validationSchema.required'/>)
})


